export const SET_PRODUCTS = 'products/set';
export const ADD_PRODUCTS_TO_LIST = 'products/add';
export const EDIT_PRODUCTS_IN_LIST = 'products/edit';
export const DELETE_PRODUCTS_FROM_LIST = 'products/delete';
export const CLEAR_PRODUCTS = 'products/clear';
